import "@jpj/ui/reset.css";
import "@jpj/ui/components.css";
import "./styles/theme.css";
import "./styles/game.css";

import { $, monEl } from "./dom";
import { hideOverlay, isOverlayOpen, runTeaser } from "@jpj/game-shell";
import { state } from "./game/state";
import { rebuildBoard } from "./game/board";
import { layout, updateHUD, refreshTrayState, restart, startEncounter } from "./game/flow";
import { attack } from "./game/combat";
import { rotateDragging } from "./game/drag";
import { skipCompare, nextCompare, relayoutReveal } from "./reveal/reveal";
import { openLearn, closeLearn, stepLearn } from "./reveal/learn";
import { setupMusic } from "./audio/music";
import { warmUpHighs } from "@jpjj/solver-core";

/* ---------- Reveal / explainer buttons (always present in the DOM) ---------- */
$("cmpSkip").addEventListener("click", skipCompare);
$("cmpNext").addEventListener("click", nextCompare);
$("learnBtn").addEventListener("click", openLearn);
$("again2").addEventListener("click", () => {
  hideOverlay("solverOverlay");
  restart();
});
$("learnBack").addEventListener("click", closeLearn);
$("lPrev").addEventListener("click", () => stepLearn(-1));
$("lNext").addEventListener("click", () => stepLearn(1));
window.addEventListener("resize", () => {
  if (isOverlayOpen("solverOverlay")) relayoutReveal();
});

/* ---------- Core game events ---------- */
monEl.addEventListener("click", attack);
monEl.addEventListener("contextmenu", (e) => e.preventDefault()); // no long-press menu on mobile
window.addEventListener("keydown", (e) => {
  if ((e.key === "r" || e.key === "R") && state.drag && state.drag.started) {
    e.preventDefault();
    rotateDragging();
  }
});
window.addEventListener("resize", layout);

const beginGame = (): void => {
  hideOverlay("introOverlay");
  startEncounter();
  warmUpHighs(); // download/initialise the WASM solver during play
};
$("beginBtn").addEventListener("click", beginGame);
$("againBtn").addEventListener("click", restart);

/* ---------- Init ---------- */
// procedural 8-bit dungeon theme (starts on the first user gesture)
setupMusic();
// the title scene stays up until the player picks "How to Play" or "Start"
runTeaser({ onStart: beginGame });
rebuildBoard();
layout();
updateHUD();
refreshTrayState();
// re-run layout once the custom fonts settle (changes available width)
if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
